import { render, staticRenderFns } from "./cuHuisarts.vue?vue&type=template&id=ef6420ce&scoped=true"
import script from "./cuHuisarts.vue?vue&type=script&lang=js"
export * from "./cuHuisarts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6420ce",
  null
  
)

export default component.exports